import { render, staticRenderFns } from "./NewAbout.vue?vue&type=template&id=cdce24a8&scoped=true&"
import script from "./NewAbout.vue?vue&type=script&lang=ts&"
export * from "./NewAbout.vue?vue&type=script&lang=ts&"
import style0 from "./NewAbout.vue?vue&type=style&index=0&id=cdce24a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdce24a8",
  null
  
)

export default component.exports